import axios from "../general/HttpClient";
import * as AccountStore from "../account/AccountStore";

export interface PermissionDefinition {
    name: string;
    displayName: string;
    description: string;
    category?: string;
}

export function ListPolicyDefinitions() {
    return axios.get<PermissionDefinition[]>("/api/identityPermissions/listPolicyDefinitions");
}

export function ListPolicies() {
    return axios.get("/api/identityPermissions/listPolicies");
}

export function GetMyPermissions() {
    return axios.get("/api/identityPermissions/getMyPermissions", {});
}

export function GetUserPermissions(userId) {
    return axios.get("/api/identityPermissions/getUserPermissions", {
        params: {
            userId,
        },
    });
}

export function GetClientPermissions(clientId) {
    return axios.get("/api/identityPermissions/getClientPermissions", {
        params: {
            clientId,
        },
    });
}

export function GiveUserPermission(userId, permission) {
    return axios.post(
        "/api/identityPermissions/giveUserPermission",
        {},
        {
            params: {
                userId,
                permission,
            },
        }
    );
}

export function RevokeUserPermission(userId, permission) {
    return axios.delete("/api/identityPermissions/revokeUserPermission", {
        params: {
            userId,
            permission,
        },
    });
}

export function GiveClientPermission(clientId, permission) {
    return axios.post(
        "/api/identityPermissions/giveClientPermission",
        {},
        {
            params: {
                clientId,
                permission,
            },
        }
    );
}

export function RevokeClientPermission(clientId, permission) {
    return axios.delete("/api/identityPermissions/revokeClientPermission", {
        params: {
            clientId,
            permission,
        },
    });
}

export function CheckCurrentUserHasPermission(permission) {
    return AccountStore.GetCurrentLoggedInUser().then((user) => {
        if (user.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
            return true;
        } else {
            return GetMyPermissions().then((response) => {
                return response.data.filter((policy) => policy.permission == permission).length > 0;
            });
        }
    });
}
